import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  receivedItems: {
    id: 'ZATIFr',
    defaultMessage: 'Received Items',
    description: 'Received Items header for Transfer Order Receiving Form',
  },
  showAdvancedFields: {
    id: '634xPL',
    defaultMessage: 'Show advanced inventory fields',
    description: 'Checkbox label to show advanced inventory fields like Lot ID in transfer order',
  },
  sku: {
    id: 'lsd1dL',
    defaultMessage: 'SKU',
    description: 'Table column header for SKU in transfer order',
  },
  warehouseLocation: {
    id: 'jL7/U6',
    defaultMessage: 'Warehouse location',
    description: 'Table column header for Warehouse location in transfer order',
  },
  select: {
    id: 'uW4wyj',
    defaultMessage: 'Select...',
    description: 'Select label for dropdown placeholder in transfer order',
  },
  lot: {
    id: '2Q8GT4',
    defaultMessage: 'Lot ID',
    description: 'Table column header for Lot ID in transfer order',
  },
  cost: {
    id: 'Of66xK',
    defaultMessage: 'Cost',
    description: 'Table column header for Cost in transfer order receiving',
  },
  accept: {
    id: '2ndVri',
    defaultMessage: 'Accept',
    description: 'Table column header for Acceptance in transfer order',
  },
  reject: {
    id: 'KtNaM7',
    defaultMessage: 'Reject',
    description: 'Table column header for Rejection in transfer order',
  },
  received: {
    id: 'j6763F',
    defaultMessage: 'Received',
    description: 'Table column header for Receiving in transfer order',
  },
  all: {
    id: 'QN3Tg1',
    defaultMessage: 'All',
    description: 'Button text to select all remaining items in transfer order',
  },
  locationRequired: {
    id: 'qrMSye',
    defaultMessage: 'Location is required',
    description: 'Error message when warehouse location is not selected',
  },
  unitOfMeasure: {
    id: 'geZGAE',
    defaultMessage: 'Unit of measure',
    description: 'Table column header for Unit of Measure in transfer order receiving',
  },
});
